module.exports = __webpack_public_path__ + "static/images/logo-dan.b8a726b68c45c74f72e4ef217c2e055f.png";